import { dom, mapActiveClass } from "../helpers/dom.js";


class FullSizes {
  constructor(props) {
    this.sizes = props.sizes || [];
    this.current = props.current || this.sizes[0] || null;
    this.onChange = props.onChange || (() => {});
  }
  init() {
    return this._makeDom();
  }
  setActive(size) {
    mapActiveClass(
      this.buttons,
      "sizes__size--active",
      button => button.textContent === size
    );
    this.current = size;
  }
  _makeDom() {
    this.buttons = this.sizes.map(size => {
      const button = dom("button.sizes__size", {}, size);
      button.addEventListener("click", () => this.onChange(size));
      return button;
    });
    this.setActive(this.current);
    return dom("div.sizes.sizes--full", {}, this.buttons);
  }
}

export default FullSizes;



// WEBPACK FOOTER //
// ./src/js/components/fullSizes.js